/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import EventBusService, { INSERT_LIQUID, BEE_INSERT_LIQUID } from 'cio/services/event-bus';
import { MergeTag } from 'cio/utils/editor-utils';
import { tracked } from '@glimmer/tracking';

interface DragAndDropLiquidModalArgs {
  onClose: () => unknown;
  mergeTags: MergeTag[];
  hasReadOnlyPermission: boolean;
}

export default class DragAndDropLiquidModal extends Component<DragAndDropLiquidModalArgs> {
  @service eventBus!: EventBusService;

  editorId = 'liquid-modal-editor';
  @tracked liquidTextBlock = null;

  @action
  insertTag(tag: MergeTag, evt: Event) {
    evt.stopPropagation();
    this.eventBus.publish(INSERT_LIQUID, [this.editorId, null], tag.name);
  }

  @action
  addLiquid(liquidTextBlock: string) {
    this.eventBus.publish(BEE_INSERT_LIQUID, liquidTextBlock);
  }
}
